<template>
    <div class="calendar-nav">
        <DxButton hint="Previos month" icon="chevronleft" styling-mode="contained" type="normal" @click="prevMonthClicked"></DxButton>
        <VueDatePicker :teleport="true" v-model="state.date" month-picker :clearable="false" @update:model-value="monthChanged">
        </VueDatePicker>
        <DxButton class="pad-after-date-picker" hint="Next month" icon="chevronright" styling-mode="contained" type="normal" @click="nextMonthClicked"></DxButton>
    </div>
</template>

<script setup lang="ts">
import { reactive } from "vue";
import { DxButton } from 'devextreme-vue';

const state = reactive({
  date: { year: (new Date).getFullYear(), month: (new Date).getMonth() },
});

const emit = defineEmits(["monthSelected"])

async function monthChanged() {
  emit("monthSelected", state.date);
}

function prevMonthClicked(e: any) { 
  if (state.date.month == 0) {
    state.date.month = 11;
    state.date.year--;
  } 
  else {
    state.date.month--;
  }
  monthChanged()
}

function nextMonthClicked(e: any) {
  if (state.date.month == 11) {
    state.date.month = 0;
    state.date.year++;
  } 
  else {
    state.date.month++;
  }
  monthChanged()
}

</script>
<style scoped lang="scss">
.calendar-nav {
  display: flex;
  flex-direction: row;
  justify-content: left;
}    
.pad-after-date-picker {
  padding-left: 42px;
}
</style>
